import {
  ATTENDEE_CHECK_GB,
  GET_GRADEBOOK_ATTENDANCE_FAILED,
  GET_GRADEBOOK_ATTENDANCE_SUCCESS,
  REQUEST_COMPLETED,
  REQUEST_STARTED,
  SAVE_GRADEBOOK_ATTENDANCE_FAILED,
  SAVE_GRADEBOOK_ATTENDANCE_SUCCESS,
} from "../constants";

const initialState = {
  attendanceData: null,
  loading: false,
  error: null,
  check: undefined,
};

export default function gradeBookAttendanceReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case REQUEST_STARTED:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case REQUEST_COMPLETED:
      return {
        ...state,
        loading: false,
      };

    case SAVE_GRADEBOOK_ATTENDANCE_SUCCESS:
      return {
        ...state,
        attendanceData: action.payload,
        error: null,
      };
    case ATTENDEE_CHECK_GB: {
      return {
        ...state,
        check: action.payload,
      };
    }
    case SAVE_GRADEBOOK_ATTENDANCE_FAILED:
      return {
        ...state,
        error: action.payload,
      };
    case GET_GRADEBOOK_ATTENDANCE_SUCCESS:
      return {
        ...state,
        attendanceData: action.payload,
        error: null,
      };

    case GET_GRADEBOOK_ATTENDANCE_FAILED:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
}
